module.exports = __webpack_public_path__ + "static/media/instagram.2eb124a3.svg";